export class Profil {
    idprofil: number;
    statut: number;
    profil: string;
}



// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/models/profil.ts